import React, { Fragment } from 'react';
import { DialogTitle, DialogContent, DialogActions, Button, Divider } from '@material-ui/core'

import { BlacklistPassengerBookings } from 'components'

export const BlacklistBookingsModal = (props) => (
  <Fragment>
    <DialogTitle>Бронювання в чорному списку</DialogTitle>
    <Divider />
    <DialogContent>
      <BlacklistPassengerBookings />
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onClose} color='secondary'>
          Вийти
      </Button>
    </DialogActions>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/BlacklistBookingsModal/BlacklistBookingsModal.js